import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";

import Form from './Form'
import ActionGet from '../../store/action/DivisionSetting/Fetch'
import ActionDelete from '../../store/action/DivisionSetting/Delete'

import "../../source/util.css"
import { IsEdit, IsCreate } from '../../store/constants'
import TextInputCustom from '../PushInteractive/CustomTextInput'
import CustomGrid from "../../infra/components/grid/custom-grid-without-search";
import ComboboxInput from "../PushInteractive/ComboboxInputCustom";
import ActionGetAllClient from "../../store/action/Client/FetchAll";
import Swal from "sweetalert2";


class Page extends Component {
    constructor(props) {
        super(props)
        this.state = {
            title: "Division",
            form: fromJS({
                show: false,
                actionType: '',
                item: fromJS({})
            }),
            formSearch: fromJS({
                "search": ""
            }),
            searchForm: fromJS({
                "client-id": '',
                "division-name": "",
            }),
            search: fromJS([
                { widthClass: 'col-sm-12', id: 'search', placeholder: 'Search', label: '', value: '' },
            ]),
            columns: [
                { className: "col-sm-3", field: "client-name", caption: "Client Name", allowSearch: true },
                { className: "col-sm-3", field: "division-name", caption: "Division Name", allowSearch: true },
                { className: "col-sm-1", cfield: "action", caption: "Actions", allowView: false }
            ],
            errors: fromJS({})
        };

        this.showContent = this.showContent.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleNew = this.handleNew.bind(this);
        this.handleEditClicked = this.handleEditClicked.bind(this);
        this.handleRemoveClicked = this.handleRemoveClicked.bind(this);
        this.handleCancelForm = this.handleCancelForm.bind(this);
        this.handlePageChanged = this.handlePageChanged.bind(this);
        this.handleFind = this.handleFind.bind(this);
    }

    componentDidMount() {
        this.props.actionGetAllClient()
    }

    handleSearch(obj) {
        this.setState({ formSearch: obj });
        this.refreshGrid(1, obj);
    }

    handleChange(field, value, label) {
        var formVal = this.state.searchForm;
        formVal = formVal.set(field, value);
        this.setState({ searchForm: formVal })
    }

    handleCancelForm(refresh) {
        if (refresh) {
            //new
            this.handleFindSearch(1);
        }
        this.setState({
            form: fromJS({
                show: false,
                actionType: '',
                item: fromJS({})
            })
        })
    }

    handleNew() {
        this.setState({
            form: fromJS({
                show: true,
                actionType: IsCreate,
                item: fromJS({})
            })
        })
    }

    handleEditClicked = (value) => {
        this.setState({
            form: fromJS({
                show: true,
                actionType: IsEdit,
                item: value
            })
        })
    }

    handlePageChanged = (value) => {
        const { formSearch } = this.state;
        this.refreshGrid(value, formSearch);
    }

    async handleRemoveClicked(value) {
        var body = {
            "data": {
                "division-id": value.get('division-id')
            }
        };
        //debugger;
        var temp = await this.props.actionDelete(body);
        if (temp.ok) {
            Swal.fire("Deleted!", "Data has been deleted.", "success");
            toast.success('Delete ' + value.get('division-name') + ' Success!', toast.POSITION.TOP_RIGHT);
            this.handleFindSearch(1);
        } else {
            Swal.fire("Failed!", "Failed to delete data.", "error");
            toast.error('Delete ' + value.get('division-name') + ' Failed!', toast.POSITION.TOP_RIGHT);
        }
    }

    refreshGrid(page, search) {
        //new
        this.handleFindSearch(page);
    }

    showContent() {
        var form = this.state.form;


        if (form.get('show')) {
            return (
                <Form
                    actionType={form.get('actionType')}
                    item={form.get('item')}
                    handleCancelForm={this.handleCancelForm}
                    handleSubmitOnForm={this.handleSubmitOnForm}
                >
                </Form>
            )
        } else {
            const items = this.props.divisionsettings ? fromJS(this.props.divisionsettings) : fromJS({});
            return (
                <CustomGrid
                    title="Division"
                    columns={this.state.columns}
                    items={items}
                    search={this.state.search}
                    handleSearch={this.handleSearch}
                    handleEditClicked={this.handleEditClicked}
                    handleRemoveClicked={this.handleRemoveClicked}
                    handlePageChanged={this.handlePageChanged}
                // handleNew={ this.handleNew }
                >
                </CustomGrid>
            )
        }
    }

    handleFind() {
        this.handleFindSearch(1);
    }

    handleFindSearch(page) {
        const { searchForm } = this.state;
        let client_id = searchForm.get('client-id');
        let division = searchForm.get('division-name');
        if (client_id == '' || client_id == null) client_id = 0
        var bodyFInd = {};
        bodyFInd = {
            "client-id": client_id,
            "division-name": division

        }
        this.props.actionGet(page, this.state.sortForm, bodyFInd);



    }

    render() {
        const { form, searchForm } = this.state;
        const title = form.get('show') ? (form.get('actionType') === IsCreate ? "Add Division" : "Edit Division") : "Division Setting";
        const classHide = title == "Division Setting" ? 'card show' : 'card hidden';

        return (
            <div className="clearfix">
                <div className="card-noborder">
                    <h4>
                        {title}
                    </h4>
                </div>
                <div className={classHide}>
                    <div className="body">
                        <div className="row">
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='client-id'
                                    value={searchForm.get('client-id')}
                                    options={fromJS({
                                        'source': this.props.clientall,
                                        'value': 'client-id',
                                        'label': 'client-name'
                                    })}
                                    onChange={(field, value, label) => this.handleChange(field, value, label)}
                                    placeholder="Client"
                                />
                            </div>
                            <div className="col-sm-6">
                                <TextInputCustom
                                    field={'division-name'}
                                    value={searchForm.get('division-name')}
                                    onChange={(field, value) => this.handleChange(field, value)}
                                    placeholder="Division Name"
                                />
                            </div>
                        </div>
                        <div className="row no-margin-bottom" >
                            <div className="col-sm-2">
                                <button type="button"
                                    className="btn btn-wide btn-success"
                                    onClick={this.handleFind}>
                                    Search
                                </button>
                            </div>
                            <div className="col-sm-1"></div>
                            <div className="col-sm-2">
                                <button type="button"
                                    className="btn btn-wide btn-success content-add"
                                    onClick={this.handleNew}>
                                    <i className="material-icons">{'add'}</i>{'Add'}
                                </button>
                            </div>

                        </div>
                    </div>

                </div>
                {
                    this.showContent()
                }
            </div>
        );
    }
}


export default connect(
    (state) => {
        return {
            clientall: state.user.clientall,
            divisionsettings: state.user.divisionsetting,
        }
    },
    dispatch => bindActionCreators({
        actionGet: ActionGet,
        actionDelete: ActionDelete,
        actionGetAllClient: ActionGetAllClient,

    }, dispatch),
)(Page);